import { ReactNode } from "react";
import { SidebarProvider } from "@/components/ui/sidebar";
import { Header } from "./Header";
import { AppSidebar } from "@/components/AppSidebar";
import { AdZoneBanner } from "@/features/ad-zones/components/AdZonePlacements";
import { cn } from "@/lib/utils";
import { AppShellProvider } from "./AppShellContext";
import { layoutStyle } from "./constants";

interface AppShellProps {
  children: ReactNode;
  showSidebar?: boolean;
}

export const AppShell = ({ children, showSidebar = true }: AppShellProps) => {
  return (
    <AppShellProvider value={{ hasShell: true, showSidebar }}>
      <SidebarProvider>
        <div className="min-h-dvh flex flex-col bg-background w-full" style={layoutStyle}>
          <Header />

          <div className="flex flex-col flex-1 w-full min-w-0 pt-[var(--header-h)]">
            <AdZoneBanner />

            <div className="flex w-full min-w-0">
              {showSidebar && (
                <aside
                  className={cn(
                    "shrink-0 overflow-visible",
                    "w-0 lg:w-[var(--sidebar-w)]",
                    "lg:sticky lg:top-[var(--header-h)] lg:self-start",
                    "lg:max-h-[calc(100dvh-var(--header-h))]",
                    "lg:overflow-y-auto lg:overflow-x-hidden lg:border-r lg:border-[#1a324d]"
                  )}
                >
                  <AppSidebar />
                </aside>
              )}

              <main className="flex-1 min-w-0 w-full max-w-full flex flex-col overflow-x-clip">
                {children}
              </main>
            </div>
          </div>
        </div>
      </SidebarProvider>
    </AppShellProvider>
  );
};
